import { HttpRequest } from '@angular/common/http';
/**
 * MiniMiser.WebApi
 * A web API for client access to patient records.   Build date: 2/19/2019 6:49:21 PM
 *
 * OpenAPI spec version: v1.0.02.19
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface PatientInformationModel {
  primaryPhoneNumber?: string;
  secondaryPhoneNumber?: string;
  workPhoneNumber?: string;
  /**
   * Permission to leave voicemail
   */
  voiceMailPermission?: boolean;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  gender?: string;
  preferredPronouns?:string;
  primaryLanguage?: string;
  placeOfEmployment?: string;
  treatmentContactEmail?: string;
  invoicingEmail?: string;
  /**
   * Permission to send emails
   */
  emailPermission?: boolean;
  socialSecurityNumber?: string;
  ethnicity?: string;
  citizenship?: string;
  /**
   * Currently enrolled in school or an education program?
   */
  currentlyEnrolledInAProgram?: boolean;
  highestEducationLevel?: string;
  emergencyContactFirstName?: string;
  emergencyContactLastName?: string;
  emergencyContactPhoneNumber?: string;
  emergencyContactRelationshipToPatient?: string;
  maritalStatus?: string;
  spouseFullName?: string;
  veteranStatus?: string;
  parentName?: string;
  signatureRequestedDate?: Date;
  intakeDate?: Date;
  dischargeDate?: Date;
  campus?: string;
  diagnosisText?: string;
  diagnosisCodeICD10?: string;
  diagnosisCodeICD9?: string;
  individualTherapist?: string;
  lastAssessmentDate?: Date;
  lastTreatmentPlanDate?: Date;
  aprn?: string;
  latency?: boolean;
  medicalNeeds?: string;
  notes?: string;
  active?: boolean;
  activedDate?: Date;
  deactivatedDate?: Date;
  /**
   * Base 64 image
   */
  photo?: string;
  /**
   * Base 64 image
   */
  photoSignature?: string;
  /**
   * ID of the inquiry information
   */
  inquiryID?: number;
  patientID?: number;
  firstName?: string;
  lastName?: string;
  preferredName?: string;
  birthdate?: Date;
  relationshipToPatient?: string;
  /**
   * This is a new client. They can edit all fields
   */
  isNewClient?: boolean;
  isOnWaitList?: boolean;
  hasActiveAuthorization?: boolean;
  hasMedClinicAuthorization?: boolean;
  hasPsychMedAuthorization?: boolean;
  inactive?: boolean;
  signedDate?: Date;
  signatureRequestPending?: boolean;
  documentToSignID?: number;
  documentsNotSigned?: number;
  hasAllRequiredDocsSigned?: boolean;
  fusionAccessCode?: string;
  insurancesReviewPending?: boolean;
  lastInsuranceReview?: Date;
  hasCurrentGoodFaithEstimate?: boolean;
  /**
   * SMS Permissions
   */
  smsAppointmentReminder?: boolean;
  smsPermission?: boolean;

  formsNotSigned?: number;
  requiredFormsNotSigned?: number;
  hasRequestAccepted?: boolean;
  isFullyResponsibleForPatient?: boolean;
  canSignForPatient?: boolean;
  canViewIntake?: boolean;
  canManageIntake?: boolean;
  canViewSchedule?: boolean;
  canManageSchedule?: boolean;
  canViewDocuments?: boolean;
  canManageDocuments?: boolean;
  canViewStatement?: boolean;
  financialResponsibilityRatio?: number;

}
